// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"CircleSpinner_Spinner__34JeV","rotate":"CircleSpinner_rotate__gUDVf","Path":"CircleSpinner_Path__3TFrr","dash":"CircleSpinner_dash__2bPIA"};